import { render, staticRenderFns } from "./error-message.vue?vue&type=template&id=4f2a9b7b"
import script from "./error-message.vue?vue&type=script&lang=ts"
export * from "./error-message.vue?vue&type=script&lang=ts"
import style0 from "./error-message.vue?vue&type=style&index=0&id=4f2a9b7b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports